var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0V24H24V0ZM18.862,9.237A9.336,9.336,0,0,1,4.5,17.527a6.6,6.6,0,0,0,4.86-1.359,3.285,3.285,0,0,1-3.066-2.28,3.3,3.3,0,0,0,1.482-.056,3.286,3.286,0,0,1-2.633-3.26,3.266,3.266,0,0,0,1.486.411A3.289,3.289,0,0,1,5.613,6.6a9.32,9.32,0,0,0,6.766,3.43,3.285,3.285,0,0,1,5.594-2.993,6.568,6.568,0,0,0,2.085-.8,3.292,3.292,0,0,1-1.443,1.816A6.578,6.578,0,0,0,20.5,7.54a6.707,6.707,0,0,1-1.638,1.7Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitter-logo.f9f166acd191562888ec1331fe2b51d0.svg";
export { ForwardRef as ReactComponent };